<template>
<div class="grid-container">
  <div class="main-section">
    <div class="result-sec">
      <p>My Post</p>
    </div>

    <div class="right-section">
      <div class="view-section">
        <!-- Sort by Views removed -->

        <div
          class="sort-btn"
          :class="{ active: currentView === 'date' }"
          @click="setSort('date')"
        >
          Sort by Date
        </div>

        <div
          class="sort-btn"
          :class="{ active: currentView === 'name' }"
          @click="setSort('name')"
        >
          Sort by Name
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>


export default {
  components: {
   
  },

data() {
  return {
    currentView: "date",
  };
},
methods: {
  setSort(type) {
    this.currentView = type;
    this.$emit('sort', type);
  }
}

};
</script>

<style scoped>
.grid-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 32px;
}

.main-section {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  padding: 10px 24px;
  box-sizing: border-box;
  background-color: #fff;
}

.result-sec p {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.view-section {
  display: flex;
  border: 1px solid #d5d7da;
  border-radius: 4px;
  overflow: hidden;
}

.sort-btn {
  padding: 8px 18px;
  font-size: 14px;
  cursor: pointer;
  background: #fff;
  color: #414651;
  transition: 0.2s;
}

.sort-btn:hover {
  background: #f5f5f5;
}

.sort-btn.active {
  background: #525252;
  color: #fff;
}

/* Mobile */
@media (max-width: 480px) {
  .main-section {
    flex-direction: row;
    padding: 10px;
    align-items: center;
    margin-top: 24px;
  }

  .result-sec p {
    font-size: 20px;
    width: auto;
  }

  .sort-btn {
    padding: 6px 12px;
    font-size: 12px;
  }

  .grid-container {
    margin: 0 !important;
  }
}

</style>
